var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel-screen" },
    [
      _c("panel-toolbar", {
        attrs: { period: _vm.period, "show-period": "" },
        on: { "update:period": _vm.changePeriod },
      }),
      _c("div", { staticClass: "panel-screen__summary" }, [
        _c("div", { staticClass: "panel-screen__summary-cell" }, [
          _c("div", { staticClass: "panel-screen__summary-label" }, [
            _vm._v(_vm._s(_vm.$t("influencer_panel.active_campaigns"))),
          ]),
          _c("div", { staticClass: "panel-screen__summary-value" }, [
            _vm._v(_vm._s(_vm.activeCount)),
          ]),
        ]),
        _c("div", { staticClass: "panel-screen__summary-cell" }, [
          _c("div", { staticClass: "panel-screen__summary-label" }, [
            _vm._v(_vm._s(_vm.$t("influencer_panel.sales"))),
          ]),
          _c("div", { staticClass: "panel-screen__summary-value" }, [
            _vm._v(_vm._s(_vm.totalSales)),
          ]),
        ]),
        _c("div", { staticClass: "panel-screen__summary-cell" }, [
          _c("div", { staticClass: "panel-screen__summary-label" }, [
            _vm._v(_vm._s(_vm.$t("influencer_panel.commission"))),
          ]),
          _c(
            "div",
            { staticClass: "panel-screen__summary-value" },
            [
              _c("hb-money", {
                attrs: { cents: _vm.totalCommissionCents, tone: "brand" },
              }),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "panel-screen__summary-cell" }, [
          _c("div", { staticClass: "panel-screen__summary-label" }, [
            _vm._v(_vm._s(_vm.$t("influencer_panel.ending_count"))),
          ]),
          _c("div", { staticClass: "panel-screen__summary-value" }, [
            _vm._v(_vm._s(_vm.endingCount)),
          ]),
        ]),
      ]),
      _c("hb-tabs", {
        attrs: { value: _vm.tab, tabs: _vm.tabs },
        on: { input: _vm.changeTab },
      }),
      _vm.tab === "minhas"
        ? [
            _c(
              "b-skeleton-wrapper",
              {
                attrs: { loading: _vm.loadingMine },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "loading",
                      fn: function () {
                        return [
                          _c(
                            "hb-section",
                            [
                              _c("b-skeleton-img", {
                                attrs: { "no-aspect": "", height: "160px" },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2627651596
                ),
              },
              [
                _vm.mineError
                  ? _c("section-error", {
                      attrs: { message: _vm.mineError },
                      on: { retry: _vm.loadMine },
                    })
                  : !_vm.joined.length
                  ? _c(
                      "hb-section",
                      { attrs: { title: _vm.$t("influencer_panel.tab_mine") } },
                      [
                        _c("hb-empty-state", {
                          attrs: {
                            title: _vm.$t("influencer_panel.no_campaigns"),
                            icon: "TrendingUpIcon",
                          },
                        }),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "panel-screen__cards" },
                      _vm._l(_vm.joined, function (item) {
                        return _c("campaign-card", {
                          key: item.id,
                          attrs: { participation: item },
                          on: {
                            "generate-link": _vm.openGenerateLink,
                            material: _vm.openMaterial,
                            info: _vm.openInfo,
                            leave: _vm.confirmLeave,
                          },
                        })
                      }),
                      1
                    ),
              ],
              1
            ),
          ]
        : _vm.tab === "disponiveis"
        ? [
            _c(
              "b-skeleton-wrapper",
              {
                attrs: { loading: _vm.loadingAvailable },
                scopedSlots: _vm._u([
                  {
                    key: "loading",
                    fn: function () {
                      return [
                        _c(
                          "hb-section",
                          [
                            _c("b-skeleton-img", {
                              attrs: { "no-aspect": "", height: "160px" },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _vm.availableError
                  ? _c("section-error", {
                      attrs: { message: _vm.availableError },
                      on: { retry: _vm.loadAvailable },
                    })
                  : _c("available-campaigns-pane", {
                      attrs: { campaigns: _vm.available },
                      on: { join: _vm.join },
                    }),
              ],
              1
            ),
          ]
        : [
            _c(
              "b-skeleton-wrapper",
              {
                attrs: { loading: _vm.loadingLinks },
                scopedSlots: _vm._u([
                  {
                    key: "loading",
                    fn: function () {
                      return [
                        _c(
                          "hb-section",
                          [
                            _c("b-skeleton-img", {
                              attrs: { "no-aspect": "", height: "160px" },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _vm.linksError
                  ? _c("section-error", {
                      attrs: { message: _vm.linksError },
                      on: { retry: _vm.loadLinks },
                    })
                  : _c("my-links-pane", {
                      attrs: { links: _vm.links },
                      on: {
                        "generate-link": function ($event) {
                          return _vm.openGenerateLink()
                        },
                      },
                    }),
              ],
              1
            ),
          ],
      _c("generate-link-modal", {
        ref: "generateLink",
        attrs: { participations: _vm.joined, preselected: _vm.linkTarget },
        on: { created: _vm.onLinkCreated },
      }),
      _c("campaign-material-modal", {
        ref: "material",
        attrs: { participation: _vm.materialTarget },
      }),
      _c("campaign-info-modal", { ref: "info" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }